.disclaimer-container {
    height: 100px;
}
